import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { isImmutable } from "@/services/backend/documents/lib/document-state";
import { Button } from "@/shared/components/ui/button";
import { Trash2 } from "lucide-react";
import t from "@/lang/lang";
import {
  Position,
  positionFieldName,
  WorkOrder,
} from "@/services/backend/htz/work-order/types/work-order";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useHtzWorkOrderDeletePositionMutation } from "@/services/backend/htz/work-order/api/work-order-api";
import { useEffect } from "react";
import { useErrValidationFailedContext } from "@/shared/lib/errors/err-validation-failed-context";

export function DeletePositionDialog({
  workOrder,
  position,
}: {
  workOrder: WorkOrder;
  position: Position;
}) {
  const [deletePosition, { isLoading, error, isSuccess }] =
    useHtzWorkOrderDeletePositionMutation();
  const { resetFields } = useErrValidationFailedContext();

  useEffect(() => {
    if (isSuccess) {
      resetFields(positionFieldName({ id: position.id }));
    }
  }, [isSuccess, position.id, resetFields]);

  const doDelete = () => {
    if (isLoading) return;

    deletePosition({ id: position.id, workOrderId: position.workOrderId });
  };

  const disabled = isImmutable(workOrder) || isLoading;

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="ghost" className="h-8 w-8 p-0" disabled={disabled}>
          <Trash2 className="h-5 w-5" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("Position wirklich löschen?")}</DialogTitle>
          <DialogDescription>
            {position.title + t(" wird unwiderruflich gelöscht.")}
          </DialogDescription>
        </DialogHeader>
        <RTKQueryErrorAlert error={error} />
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">{t("Abbrechen")}</Button>
          </DialogClose>
          <Button variant="destructive" onClick={doDelete} disabled={disabled}>
            {t("Löschen")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
